<template>
  <LoginHeader :logo="logo"/>
  <el-tabs v-model="activeName" tab-position="left" style="overflow-y: auto; height: 100%;" class="demo-tabs">
    <el-tab-pane label="供销平台" name="agreement"><div  style="padding: 16px;"><ScmPrivacyPolicy/></div></el-tab-pane>
    <el-tab-pane label="慧经营" name="hjyAgreement"><div style="padding: 16px"><HjyPrivacyPolicyHtml/></div></el-tab-pane>
    <el-tab-pane label="极速版erp" name="erpxAgreement"><div style="padding: 16px"><ErpxPrivacyPolicyHtml/></div></el-tab-pane>
  </el-tabs>
</template>

<script lang="ts" setup>
import logo from "@/assets/logo-default.png"
import ScmPrivacyPolicy from "./ScmPrivacyPolicy.vue";
import HjyPrivacyPolicyHtml from "./HjyPrivacyPolicy.vue";
import ErpxPrivacyPolicyHtml from "./ErpxPrivacyPolicy.vue";

document.title='慧策登录'
const activeName = ref('agreement')

</script>

<style scoped lang="scss">
.title {
  font-size: 24px;
  font-weight: 700;
  color: #333333;
  line-height: 48px;
  text-align: center;
}

.sub-title {
  margin: 24px 0;
  font-size: 18px;
  line-height: 24px;
  font-weight: 700;
  color: #333333;
}

.body {
  font-size: 14px;
  font-weight: 400;
  color: rgba(0, 0, 0, .7);
  line-height: 22px;
  margin: 8px 0;
}
.ite-label{
  height: 100%;
  overflow-y: auto;
}
</style>